import { Component } from "react";

/**
 * Fängt Render-Fehler ab, die sonst die ganze Seite komplett weiss/leer
 * lassen (React unmounted bei einem unbehandelten Fehler den ganzen Baum).
 * Zeigt stattdessen einen Hinweis + Reload-Button und loggt den Fehler
 * in die Konsole (mit Sourcemap sichtbar, statt minifiziert).
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary hat einen Render-Fehler abgefangen:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white px-4">
          <div className="max-w-md text-center">
            <p className="text-primary font-extrabold uppercase text-2xl mb-3">
              Etwas ist schiefgelaufen
            </p>
            <p className="text-dark/60 text-sm mb-6">
              Diese Seite konnte nicht geladen werden. Ein Reload behebt das meistens.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-primary text-white font-bold uppercase text-sm px-6 py-3 hover:bg-accent transition-colors"
            >
              Seite neu laden
            </button>
            {import.meta.env.DEV && this.state.error && (
              <pre className="mt-6 text-left text-xs text-red-600 bg-red-50 p-3 overflow-auto">
                {String(this.state.error?.stack || this.state.error)}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
